import type {
  DataGridColumnSchema,
  DataGridContract,
  DataGridParameterSchema,
} from './types'

export function defineDataGridContract<Values>() {
  return <
    const Id extends string,
    const Key extends keyof Values & string,
    const Columns extends Readonly<
      Partial<Record<keyof Values & string, DataGridColumnSchema>>
    >,
    const ParameterSchemas extends Readonly<Record<string, DataGridParameterSchema>> = Record<never, never>,
  >(contract: Omit<DataGridContract<Values, Id, Key, Columns, ParameterSchemas>, '__values'>) =>
    contract as DataGridContract<Values, Id, Key, Columns, ParameterSchemas>
}
